import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=c4698d00&"
import script from "./DeviceCard.vue?vue&type=script&lang=js&"
export * from "./DeviceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4698d00')) {
      api.createRecord('c4698d00', component.options)
    } else {
      api.reload('c4698d00', component.options)
    }
    module.hot.accept("./DeviceCard.vue?vue&type=template&id=c4698d00&", function () {
      api.rerender('c4698d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/devicesoverview/deviceslist/device/DeviceCard.vue"
export default component.exports